import React from 'react';

export const Logo = (props) => {
  return (
    <img src='/logo.png' alt='logo' width='100px' />
  );
};
